import NavbarPom from "./navbar_pomona"
import "../css/pomonamap.css"
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";


const PomMap = () => {
    return (
        <div>
            <NavbarPom />
            <div className="all-dorms">
                <div className="harwood-whole-box">
                    <h2>Harwood</h2>
                    <Link className="nav-link" to="/countdown-pom">
                    <div className="harwood-laundry-box">
                        <div className="harwood-column-1">
                            <div className="harwood-washer-title"> Washer </div>
                            <div className="washer">
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                            </div>
                        </div>
                        <div className="harwood-column-2">
                            <div className="harwood-dryer-title">Dryer </div>
                            <div className="dryer">
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                            </div>
                        </div>
                    </div>
                    </Link>




                </div>
                <div className="harwood-whole-box">
                    <h2>Lyon</h2>
                    <div className="harwood-laundry-box">
                        <div className="harwood-column-1">
                            <div className="harwood-washer-title"> Washer </div>
                            <div className="washer">
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                            </div>
                        </div>
                        <div className="harwood-column-2">
                            <div className="harwood-dryer-title">Dryer </div>
                            <div className="dryer">
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                            </div>
                        </div>
                    </div>



                </div>
                <div className="harwood-whole-box">
                    <h2>Wig</h2>
                    <div className="harwood-laundry-box">
                        <div className="harwood-column-1">
                            <div className="harwood-washer-title"> Washer </div>
                            <div className="washer">
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                            </div>
                        </div>
                        <div className="harwood-column-2">
                            <div className="harwood-dryer-title">Dryer </div>
                            <div className="dryer">
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                            </div>
                        </div>
                    </div>



                </div>
                <div className="harwood-whole-box">
                    <h2>Gibson</h2>
                    <div className="harwood-laundry-box">
                        <div className="harwood-column-1">
                            <div className="harwood-washer-title"> Washer </div>
                            <div className="washer">
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                            </div>
                        </div>
                        <div className="harwood-column-2">
                            <div className="harwood-dryer-title">Dryer </div>
                            <div className="dryer">
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                            </div>
                        </div>
                    </div>



                </div>
                <div className="harwood-whole-box">
                    <h2>Mudd</h2>
                    <div className="harwood-laundry-box">
                        <div className="harwood-column-1">
                            <div className="harwood-washer-title"> Washer </div>
                            <div className="washer">
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                            </div>
                        </div>
                        <div className="harwood-column-2">
                            <div className="harwood-dryer-title">Dryer </div>
                            <div className="dryer">
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                            </div>
                        </div>
                    </div>



                </div>
                <div className="harwood-whole-box">
                    <h2>Blaisdell</h2>
                    <div className="harwood-laundry-box">
                        <div className="harwood-column-1">
                            <div className="harwood-washer-title"> Washer </div>
                            <div className="washer">
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                            </div>
                        </div>
                        <div className="harwood-column-2">
                            <div className="harwood-dryer-title">Dryer </div>
                            <div className="dryer">
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item green"></div>
                                <div className="harwood-laundry-box-item red"></div>
                                <div className="harwood-laundry-box-item red"></div>
                            </div>
                        </div>
                    </div>



                </div>
            </div>

        </div>
    )
}

export default PomMap